
import { translate } from './translation';
const onHandCheckLeadTimeLanguage = (translatePrefix, leadTimeVendor, translation) => {
    if (translation == '') {
        return translate(translatePrefix).replace('{0}', leadTimeVendor);
    }
    else {
        let trans = '';
        if (leadTimeVendor != null || leadTimeVendor != undefined) {
            trans = leadTimeVendor + ' ' + translate(translation);
        } else {
            trans = leadTimeVendor;
        }
        return translate(translatePrefix).replace('{0}', trans);
    }
};
export default onHandCheckLeadTimeLanguage;